import * as locale from 'blockly/msg/ja'
import { Translation } from './translation'

export class CommonResource extends Translation {
  title = {
    hiragana: 'ろぶくらっち',
    kanji: 'ロブクラッチ',
  }
  button_back = {
    hiragana: 'もどる',
    kanji: '戻る',
  }
  not_connected_error = {
    hiragana: 'ネットにせつぞくできていないみたいです。',
    kanji: 'ネットに接続できていないみたいです。',
  }
  chapter_refresh_error = {
    hiragana:
      'どうがのしちょうじょうほうをこうしんできませんでした。さくひんのへんしゅうはつづけられます。',
    kanji: '動画の視聴情報を更新できませんでした。作品の編集は続けられます。',
  }
  chapter_refresh_retry = {
    hiragana: 'もういちどためす',
    kanji: '再試行',
  }
  no_project_id = {
    hiragana: 'プロジェクトIDがありません',
    kanji: 'プロジェクトIDがありません',
  }
  invalid_mission_id = {
    hiragana: ' むこうなミッションIDです',
    kanji: '無効なミッションIDです',
  }
  no_workspace_data = {
    hiragana: 'ワークスペースデータがありません',
    kanji: 'ワークスペースデータがありません',
  }
  project_fetch_error = {
    hiragana: 'プロジェクトのしゅとくエラー：',
    kanji: 'プロジェクトの取得エラー：',
  }
  post_to_community = {
    hiragana: 'コミュニティにとうこう',
    kanji: 'コミュニティに投稿',
  }
  lets_post_to_community = {
    hiragana: 'コミュニティにとうこうしよう！',
    kanji: 'コミュニティに投稿しよう！',
  }
  download = {
    hiragana: 'ダウンロード',
    kanji: 'ダウンロード',
  }
  modal_download_title = {
    hiragana: 'ダウンロードしたファイルを\r\nRobloxStudioでひらこう',
    kanji: 'ダウンロードしたファイルを\r\nRobloxStudioで開こう',
  }
  modal_download_card_title = {
    hiragana:
      '①みぎうえにでてきた\r\nファイルをクリックしよう\r\n（もじはまいかいかわるよ）',
    kanji:
      '①右上に出てきた\r\nファイルをクリックしよう\r\n（文字は毎回変わるよ）',
  }
  download_and_start_mission = {
    hiragana: 'ダウンロードして\r\nミッションをはじめよう！',
    kanji: 'ダウンロードして\r\nミッションを始めよう！',
  }
  download_failed_title = {
    hiragana: 'ダウンロードできませんでした',
    kanji: 'ダウンロードできませんでした',
  }
  download_failed_detail = {
    hiragana: 'じかんをおいてもういちどためしてください',
    kanji: '時間をおいてもう一度試してください',
  }
  connect = {
    hiragana: 'せつぞく',
    kanji: '接続',
  }
  show_code = {
    hiragana: 'コードをみる',
    kanji: 'コードを見る',
  }
  code_copy_button = {
    hiragana: 'コピー',
    kanji: 'コピー',
  }
  code_copied = {
    hiragana: 'コードをコピーしました',
    kanji: 'コードをコピーしました',
  }
  code_copy_failed = {
    hiragana: 'コードのコピーにしっぱいしました',
    kanji: 'コードのコピーに失敗しました',
  }
  button_language = {
    hiragana: 'ひらがな',
    kanji: '漢字',
  }
  file_menu = {
    hiragana: 'ファイル',
    kanji: 'ファイル',
  }
  file_new = {
    hiragana: 'あたらしくつくる',
    kanji: '新しく作る',
  }
  file_save = {
    hiragana: 'ただちにほぞん',
    kanji: 'ただちに保存',
  }
  file_copy_and_save = {
    hiragana: 'コピーしてほぞん',
    kanji: 'コピーして保存',
  }
  file_review = {
    hiragana: 'ほぞんしたさくひんをみる',
    kanji: '保存した作品を見る',
  }
  menu_how_to_setup = {
    hiragana: 'セットアップほうほう',
    kanji: 'セットアップ方法',
  }
  link = {
    hiragana: 'みせつぞく',
    kanji: '未接続',
  }
  linked = {
    hiragana: 'せつぞくOK',
    kanji: '接続OK',
  }
  update = {
    hiragana: 'はんえい',
    kanji: '反映',
  }
  studio_connection_error = {
    hiragana: 'Roblox Studioへのせつぞくちゅうにエラーがはっせいしました',
    kanji: 'Roblox Studioへの接続中にエラーが発生しました',
  }
  connection_lost_error = {
    hiragana: 'Roblox Studioとのせつぞくがきれました',
    kanji: 'Roblox Studioとの接続が切れました',
  }
  remix = {
    hiragana: 'リミックス',
    kanji: 'リミックス',
  }
  default_title = {
    hiragana: 'あたらしいプロジェクト',
    kanji: '新しいプロジェクト',
  }
  copy_suffix = {
    hiragana: 'コピー',
    kanji: 'コピー',
  }
  remix_suffix = {
    hiragana: 'リミックス',
    kanji: 'リミックス',
  }
  untitled_project = {
    hiragana: 'タイトルなし',
    kanji: 'タイトルなし',
  }
  error = {
    hiragana: 'エラーがはっせいしました',
    kanji: 'エラーが発生しました',
  }
  project_create_error = {
    hiragana: 'プロジェクトのさくせいエラー',
    kanji: 'プロジェクトの作成エラー',
  }
  project_copy_error = {
    hiragana: 'プロジェクトのコピーエラー',
    kanji: 'プロジェクトのコピーエラー',
  }
  project_save_error = {
    hiragana: 'プロジェクトのほぞんエラー',
    kanji: 'プロジェクトの保存エラー',
  }
  project_update_error = {
    hiragana: 'プロジェクトのこうしんエラー',
    kanji: 'プロジェクトの更新エラー',
  }
  empty_title_error = {
    hiragana: 'タイトルはくうらんにできません',
    kanji: 'タイトルは空欄にできません',
  }
  how_to_setup = {
    hiragana: 'セットアップのやりかた',
    kanji: 'セットアップのやり方',
  }

  end_setup = {
    hiragana: 'スライドをみてセットアップが\r\nおわったのでこのがめんをとじる',
    kanji: 'スライドを見てセットアップが\r\n終わったのでこの画面を閉じる',
  }
  description_setup_buttons = {
    hiragana: 'スライドないのステップ2からつかうボタンだよ→',
    kanji: 'スライド内のステップ2からつかうボタンだよ→',
  }

  setup_help_link_prefix = {
    hiragana: 'スライドどおりにうまくいかないばあいは',
    kanji: 'スライド通りにうまくいかない場合は',
  }

  setup_help_link_text = {
    hiragana: 'こちら',
    kanji: 'こちら',
  }

  setup_help_link_suffix = {
    hiragana: 'をごかくにんください',
    kanji: 'をご確認ください',
  }

  setup_contact_prefix = {
    hiragana: '💡 こまったときは',
    kanji: '💡 お困りの際は',
  }

  setup_contact_suffix = {
    hiragana: 'へおといあわせください',
    kanji: 'へお問い合わせください',
  }

  how_to_play_button = {
    hiragana: 'あそびかた',
    kanji: '遊び方',
  }
  how_to_play_title = {
    hiragana: 'さくひんのあそびかた',
    kanji: '作品の遊び方',
  }
  how_to_play_modal_title = {
    hiragana:
      '「リミックス」→「ダウンロード」\r\n→「みせつぞく」を\r\nじゅんばんにおしてみよう',
    kanji:
      '「リミックス」→「ダウンロード」\r\n→「未接続」を\r\n順番に押してみよう',
  }
  how_to_play_help1 = {
    hiragana: ' はじめてつかうひとは\r\nさきに「',
    kanji: ' 初めて使う人は\r\n先に「',
  }
  how_to_play_help2 = {
    hiragana: 'セットアップ',
    kanji: 'セットアップ',
  }
  how_to_play_help3 = {
    hiragana: '」からやってみてね',
    kanji: '」からやってみてね',
  }

  how_to_reconnect = {
    hiragana: 'せつぞくの\r\nやりかた',
    kanji: '接続のやり方',
  }

  reconnect_notice_text = {
    hiragana: '※Roblox Studioをとじてから①②のさぎょうをしてください。',
    kanji: '接続のやり方',
  }

  reconnect_step1 = {
    hiragana: '①あおいボタンからファイルをダウンロードしてひらく',
    kanji: '①青いボタンからファイルをダウンロードして開く',
  }
  reconnect_step2 = {
    hiragana:
      '②[OK]→[はじめる]の\r\nじゅんばんでクリックして\r\nせつぞくかんりょう！',
    kanji: '②[OK]→[はじめる]の\r\n順番でクリックして\r\n接続完了！',
  }
  connect_help = {
    hiragana:
      'うえの「コピー」をクリックして\r\nロブロックススタジオに\r\nはりつけよう',
    kanji:
      '上の「コピー」をクリックして\r\nロブロックススタジオに\r\n貼り付けよう',
  }
  reconnect_help1 = {
    hiragana: ' ダメだったときは、まわりのおとなと「',
    kanji: ' ダメだったときは、周りの大人と「',
  }
  reconnect_help2 = {
    hiragana: 'このせつめい',
    kanji: 'この説明',
  }
  reconnect_help3 = {
    hiragana: '」をみてみよう',
    kanji: '」を見てみよう',
  }
  reconnect_help4 = {
    hiragana: '②でコードをいれるがめんがでたら「✕みせつぞく」をクリックしよう',
    kanji: '②でコードを入れる画面が出たら「✕未接続」をクリックしよう',
  }

  close_button = {
    hiragana: 'とじる',
    kanji: '閉じる',
  }
  download_instruction_title = {
    hiragana: 'ダウンロードしたファイルをロブロックススタジオにアップしよう',
    kanji: 'ダウンロードしたファイルをロブロックススタジオにアップしよう',
  }

  linkage_connection_code = {
    hiragana: 'せつぞくコード：{CODE}',
    kanji: '接続コード：{CODE}',
  }
  linkage_code_copied = {
    hiragana: 'コードをコピーしました',
    kanji: 'コードをコピーしました',
  }
  linkage_copy_button = {
    hiragana: 'コピー',
    kanji: 'コピー',
  }
  connection_established = {
    hiragana: 'Roblox Studioとせつぞくされました',
    kanji: 'Roblox Studioと接続されました',
  }
  loading_screen_text = {
    hiragana: 'プロジェクトをよみこみちゅう...',
    kanji: 'プロジェクトを読み込み中...',
  }
  no_projects_yet = {
    hiragana: 'まださくひんをつくってないよ',
    kanji: 'まだ作品を作ってないよ',
  }
  no_projects_yet_license = {
    hiragana:
      'このタブをとじて、\r\nミッションページから\r\nさくひんをつくろう！',
    kanji: 'このタブを閉じて、\r\nミッションページから\r\n作品を作ろう！',
  }
  back_to_town = {
    hiragana: 'タウンへもどる',
    kanji: 'タウンへ戻る',
  }
  project_list_title = {
    hiragana: 'マイプロジェクト',
    kanji: 'マイプロジェクト',
  }
  stage_label = {
    hiragana: 'ステージ',
    kanji: 'ステージ',
  }
  mission_label = {
    hiragana: 'ミッション',
    kanji: 'ミッション',
  }
  updated_at_label = {
    hiragana: 'さいごのこうしん：',
    kanji: '最後の更新：',
  }
  continue_modal_title = {
    hiragana: 'ぜんかいのつづきからできるファイルがあるよ！',
    kanji: '前回の続きからできるファイルがあるよ！',
  }
  continue_modal_resume = {
    hiragana: 'つづきから',
    kanji: '続きから',
  }
  continue_modal_new = {
    hiragana: 'はじめから',
    kanji: 'はじめから',
  }
  confirm_delete_project = {
    hiragana: 'ほんとうにさくじょしますか？',
    kanji: '本当に削除しますか？',
  }
  delete_button = {
    hiragana: 'さくじょ',
    kanji: '削除',
  }
  delete_project_error = {
    hiragana: 'プロジェクトのさくじょエラー',
    kanji: 'プロジェクトの削除エラー',
  }
  get_project_list_error = {
    hiragana: 'プロジェクトリストのしゅとくエラー',
    kanji: 'プロジェクトリストの取得エラー',
  }
  cancel_button = {
    hiragana: 'キャンセル',
    kanji: 'キャンセル',
  }
  shared_url_copied = {
    hiragana: 'URLをコピーしました',
    kanji: 'URLをコピーしました',
  }
  to_share = {
    hiragana: 'きょうゆうする',
    kanji: '共有する',
  }
  sharing = {
    hiragana: 'きょうゆうちゅう',
    kanji: '共有中',
  }
  shared = {
    hiragana: 'きょうゆうしました！',
    kanji: '共有しました！',
  }
  error_not_shared_project = {
    hiragana: 'きょうゆうされてないプロジェクトです',
    kanji: '共有されてないプロジェクトです',
  }
  confirm_stop_sharing = {
    hiragana: 'きょうゆうをやめますか？',
    kanji: '共有をやめますか？',
  }
  stop_sharing_button = {
    hiragana: 'きょうゆうをやめる',
    kanji: '共有をやめる',
  }
  done = {
    hiragana: 'できた！',
    kanji: '出来た！',
  }

  // Block messages
  // Control
  C_CONTROL = {
    hiragana: 'せいぎょ',
    kanji: '制御',
  }
  B_DESTROY = {
    hiragana: 'さくじょする',
    kanji: '削除する',
  }
  B_FOREVER = {
    kanji: 'ずっと',
  }
  B_IF = {
    kanji: 'もし %1 なら',
  }
  B_ELSE = {
    kanji: 'でなければ',
  }
  B_REPEAT = {
    hiragana: '%1 かいくりかえす',
    kanji: '%1 回繰り返す',
  }
  B_WAIT = {
    hiragana: '%1 びょうまつ',
    kanji: '%1 秒待つ',
  }
  B_WHILE = {
    hiragana: '%1 までくりかえす',
    kanji: '%1 まで繰り返す',
  }
  B_CLONE = {
    hiragana: '%1 のクローンをつくる',
    kanji: '%1 のクローンを作る',
  }

  // Events
  C_EVENTS = {
    hiragana: 'イベント',
    kanji: 'イベント',
  }
  B_SET_HEALTH_TO = {
    hiragana: 'キャラクターのたいりょくを %1 にする',
    kanji: 'キャラクターの体力を %1 にする',
  }
  B_SET_JUMP_POWER_TO = {
    hiragana: 'キャラクターのジャンプりょくを %1 にする',
    kanji: 'キャラクターのジャンプ力を %1 にする',
  }
  B_SET_WALK_SPEED_TO = {
    hiragana: 'キャラクターのあるくはやさを %1 にする',
    kanji: 'キャラクターの歩く速さを %1 にする',
  }
  B_ON_PLAY = {
    kanji: 'プレイしたとき',
  }
  B_ON_MESSAGE = {
    hiragana: '%1 をうけとったとき',
    kanji: '%1 を受け取った時',
  }
  B_SEND_MESSAGE = {
    hiragana: '%1 をおくる',
    kanji: '%1 を送る',
  }
  delete_message = {
    kanji: '「%1」メッセージを削除',
    hiragana: '「%1」メッセージをさくじょ',
  }
  new_message = {
    kanji: '新しいメッセージ…',
    hiragana: 'あたらしいメッセージ…',
  }
  enter_message = {
    kanji: '新しいメッセージを入力してください',
    hiragana: 'あたらしいメッセージをにゅうりょくしてください',
  }
  B_ON_TOUCH_CHARACTER = {
    hiragana: 'キャラクターがふれたとき',
    kanji: 'キャラクターが触れたとき',
  }
  B_SET_CLICKABLE = {
    kanji: 'クリックできるようにする',
  }
  B_UNSET_CLICKABLE = {
    kanji: 'クリックできないようにする',
  }
  B_ON_CLICKED = {
    kanji: 'クリックされたとき',
  }
  B_ON_TOUCH_OBJECT = {
    hiragana: '%1 がふれたとき',
    kanji: '%1 が触れたとき',
  }

  // Looks
  C_LOOKS = {
    hiragana: 'みため',
    kanji: '見た目',
  }
  B_SHOW_MESSAGE = {
    hiragana: '%1 としゅつりょくにひょうじする',
    kanji: '%1 と出力に表示する',
  }
  B_SET_SIZE_TO = {
    hiragana: 'おおきさを %1 にする',
    kanji: '大きさを %1 にする',
  }
  B_WHITE = {
    hiragana: 'しろ',
    kanji: '白',
  }
  B_GRAY = {
    hiragana: 'はいいろ',
    kanji: '灰色',
  }
  B_DARK_GRAY = {
    hiragana: 'こいはいいろ',
    kanji: '濃い灰色',
  }
  B_BLACK = {
    hiragana: 'くろ',
    kanji: '黒',
  }
  B_RED = {
    hiragana: 'あか',
    kanji: '赤',
  }
  B_YELLOW = {
    hiragana: 'きいろ',
    kanji: '黄色',
  }
  B_GREEN = {
    hiragana: 'みどり',
    kanji: '緑',
  }
  B_BLUE = {
    hiragana: 'あお',
    kanji: '青',
  }
  B_SET_BRICK_COLOR_TO = {
    hiragana: 'いろを %1 にする',
    kanji: '色を %1 にする',
  }
  B_PLASTIC = {
    kanji: 'プラスチック',
  }
  B_SMOOTH_PLASTIC = {
    hiragana: 'なめらかなプラスチック',
    kanji: '滑らかなプラスチック',
  }
  B_NEON = {
    kanji: 'ネオン',
  }
  B_WOOD = {
    hiragana: 'もくざい',
    kanji: '木材',
  }
  B_WOOD_PLANKS = {
    hiragana: 'もくはん',
    kanji: '木版',
  }
  B_MARBLE = {
    hiragana: 'だいりせき',
    kanji: '大理石',
  }
  B_BASALT = {
    hiragana: 'げんぶがん',
    kanji: '玄武岩',
  }
  B_SLATE = {
    kanji: ' スレート',
  }
  B_CRACKED_LAVA = {
    hiragana: 'われたようがん',
    kanji: '割れた溶岩',
  }
  B_CONCRETE = {
    kanji: 'コンクリート',
  }
  B_LIMESTONE = {
    hiragana: 'せっかいがん',
    kanji: '石灰岩',
  }
  B_GRANITE = {
    hiragana: 'かこうがん',
    kanji: '花崗岩',
  }
  B_PAVEMENT = {
    hiragana: 'ほそう',
    kanji: '舗装',
  }
  B_BRICK = {
    kanji: 'レンガ',
  }
  B_PEBBLE = {
    hiragana: 'こいし',
    kanji: '小石',
  }
  B_COBBLESTONE = {
    hiragana: 'いしちょう',
    kanji: '石畳',
  }
  B_ROCK = {
    hiragana: 'いわ',
    kanji: '岩',
  }
  B_SANDSTONE = {
    hiragana: 'さごく',
    kanji: '砂岩',
  }
  B_CORRODED_METAL = {
    hiragana: 'ふしょくしたきんぞく',
    kanji: '腐食した金属',
  }
  B_DIAMOND_PLATE = {
    kanji: 'ダイヤモンドプレート',
  }
  B_FOIL = {
    kanji: 'ホイル',
  }
  B_METAL = {
    hiragana: 'きんぞく',
    kanji: '金属',
  }
  B_GRASS = {
    hiragana: 'くさ',
    kanji: '草',
  }
  B_LEAFY_GRASS = {
    hiragana: 'はのあるくさ',
    kanji: '葉のある草',
  }
  B_SAND = {
    hiragana: 'すな',
    kanji: '砂',
  }
  B_FABRIC = {
    hiragana: 'ぬの',
    kanji: '布',
  }
  B_SNOW = {
    hiragana: 'ゆき',
    kanji: '雪',
  }
  B_MUD = {
    hiragana: 'どろ',
    kanji: '泥',
  }
  B_GROUND = {
    hiragana: 'じめん',
    kanji: '地面',
  }
  B_ASPHALT = {
    kanji: 'アスファルト',
  }
  B_SALT = {
    hiragana: 'しお',
    kanji: '塩',
  }
  B_ICE = {
    hiragana: 'こおり',
    kanji: '氷',
  }
  B_GLACIER = {
    hiragana: 'ひょうが',
    kanji: '氷河',
  }
  B_GLASS = {
    kanji: 'ガラス',
  }
  B_FORCE_FIELD = {
    kanji: 'フォースフィールド',
  }
  B_AIR = {
    hiragana: 'くうき',
    kanji: '空気',
  }
  B_WATER = {
    hiragana: 'みず',
    kanji: '水',
  }
  B_CUPBOARD = {
    hiragana: 'しょっきだな',
    kanji: '食器棚',
  }
  B_CARPET = {
    kanji: 'カーペット',
  }
  B_CERAMIC_TILES = {
    hiragana: 'せっきたいる',
    kanji: 'セラミックタイル',
  }
  B_CLAY_ROOF_TILES = {
    hiragana: 'ねんどやねたいる',
    kanji: '粘土屋根タイル',
  }
  B_ROOF_SHINGLES = {
    hiragana: 'やねいた',
    kanji: '屋根板',
  }
  B_LEATHER = {
    hiragana: 'かわ',
    kanji: '革',
  }
  B_PLASTER = {
    hiragana: 'せっこう',
    kanji: '石膏',
  }
  B_RUBBER = {
    hiragana: 'ゴム',
    kanji: 'ゴム',
  }
  B_SET_MATERIAL_TO = {
    hiragana: 'そざいを %1 にする',
    kanji: '素材を %1 にする',
  }
  B_CHANGE_SIZE_BY = {
    hiragana: 'おおきさを %1 ずつかえる',
    kanji: '大きさを %1 ずつ変える',
  }
  B_SHOW = {
    hiragana: 'ひょうじする',
    kanji: '表示する',
  }
  B_HIDE = {
    hiragana: 'かくす',
    kanji: '隠す',
  }
  B_SEE_THROUGH = {
    hiragana: 'はんとうめいにする',
    kanji: '半透明にする',
  }
  B_BRICK_COLOR = {
    hiragana: 'いろ',
    kanji: '色',
  }
  B_MATERIAL = {
    hiragana: 'そざい',
    kanji: '素材',
  }
  B_X_SIZE = {
    hiragana: 'Xのおおきさ',
    kanji: 'Xの大きさ',
  }
  B_Y_SIZE = {
    hiragana: 'Yのおおきさ',
    kanji: 'Yの大きさ',
  }
  B_Z_SIZE = {
    hiragana: 'Zのおおきさ',
    kanji: 'Zの大きさ',
  }
  B_SET_X_SIZE_TO = {
    hiragana: 'Xのおおきさを %1 にする',
    kanji: 'Xの大きさを %1 にする',
  }
  B_SET_Y_SIZE_TO = {
    hiragana: 'Yのおおきさを %1 にする',
    kanji: 'Yの大きさを %1 にする',
  }
  B_SET_Z_SIZE_TO = {
    hiragana: 'Zのおおきさを %1 にする',
    kanji: 'Zの大きさを %1 にする',
  }
  B_SET_XYZ_SIZE_TO = {
    hiragana: 'Xのおおきさを %1 、Yのおおきさを %2 、Zのおおきさを %3 にする',
    kanji: 'Xの大きさを %1 、Yの大きさを %2 、Zの大きさを %3 にする',
  }
  B_CHANGE_X_SIZE_BY = {
    hiragana: 'おおきさXを %1 ずつかえる',
    kanji: '大きさXを %1 ずつ変える',
  }
  B_CHANGE_Y_SIZE_BY = {
    hiragana: 'おおきさYを %1 ずつかえる',
    kanji: '大きさYを %1 ずつ変える',
  }
  B_CHANGE_Z_SIZE_BY = {
    hiragana: 'おおきさZを %1 ずつかえる',
    kanji: '大きさZを %1 ずつ変える',
  }
  B_SET_TRANSPARENCY_TO = {
    hiragana: 'とうめいどを %1 ％にする',
    kanji: '透明度を %1 ％にする',
  }

  // Movement
  C_MOVEMENT = {
    hiragana: 'うごき',
    kanji: '動き',
  }
  B_SET_CAN_COLLIDE = {
    hiragana: 'あたるようにする',
    kanji: '当たるようにする',
  }
  B_UNSET_CAN_COLLIDE = {
    hiragana: 'あたらないようにする',
    kanji: '当たらないようにする',
  }
  B_SET_ANCHORED = {
    hiragana: 'うごかないようにする',
    kanji: '動かないようにする',
  }
  B_UNSET_ANCHORED = {
    hiragana: 'うごくようにする',
    kanji: '動くようにする',
  }
  B_MOVE_STEPS = {
    hiragana: '%1 ほうごかす',
    kanji: '%1 歩動かす',
  }
  B_SET_XYZ_POSITION_TO = {
    hiragana: 'Xざひょうを %1 、Yざひょうを %2 、Zざひょうを %3 にする',
    kanji: 'X座標を %1、Y座標を %2、Z座標を %3 にする',
  }
  B_SET_X_TO = {
    hiragana: 'Xざひょうを %1 にする',
    kanji: 'X座標を %1 にする',
  }
  B_SET_Y_TO = {
    hiragana: 'Yざひょうを %1 にする',
    kanji: 'Y座標を %1 にする',
  }
  B_SET_Z_TO = {
    hiragana: 'Zざひょうを %1 にする',
    kanji: 'Z座標を %1 にする',
  }
  B_X_POSITION = {
    hiragana: 'Xざひょう',
    kanji: 'X座標',
  }
  B_Y_POSITION = {
    hiragana: 'Yざひょう',
    kanji: 'Y座標',
  }
  B_Z_POSITION = {
    hiragana: 'Zざひょう',
    kanji: 'Z座標',
  }
  B_CHANGE_X_POSITION_BY = {
    hiragana: 'Xざひょうを %1 ずつかえる',
    kanji: 'X座標を %1 ずつ変える',
  }
  B_CHANGE_Y_POSITION_BY = {
    hiragana: 'Yざひょうを %1 ずつかえる',
    kanji: 'Y座標を %1 ずつ変える',
  }
  B_CHANGE_Z_POSITION_BY = {
    hiragana: 'Zざひょうを %1 ずつかえる',
    kanji: 'Z座標を %1 ずつ変える',
  }
  B_SET_Y_ORIENTATION_TO = {
    hiragana: '%1 どにむける',
    kanji: '%1 度に向ける',
  }
  B_TURN_RIGHT_BY = {
    hiragana: '%1 どまわす',
    kanji: '%1 度回す',
  }
  B_TURN_LEFT_BY = {
    hiragana: '%1 どまわす',
    kanji: '%1 度回す',
  }
  B_CHANGE_X_ORIENTATION_BY = {
    hiragana: 'Xほうこうを %1 どずつまわす',
    kanji: 'X方向に %1 度ずつ回す',
  }
  B_CHANGE_Y_ORIENTATION_BY = {
    hiragana: 'Yほうこうを %1 どずつまわす',
    kanji: 'Y方向に %1 度ずつ回す',
  }
  B_CHANGE_Z_ORIENTATION_BY = {
    hiragana: 'Zほうこうを %1 どずつまわす',
    kanji: 'Z方向に %1 度ずつ回す',
  }
  B_SET_XYZ_ORIENTATION_TO = {
    hiragana: 'Xほうこうを %1 ど、Yほうこうを %2 ど、Zほうこうを %3 どにむける',
    kanji: 'X方向を %1 度、Y方向を %2 度、Z方向を %3 度に向ける',
  }
  B_X_ORIENTATION = {
    hiragana: 'Xほうこうのむき',
    kanji: 'X方向の向き',
  }
  B_Y_ORIENTATION = {
    hiragana: 'Yほうこうのむき',
    kanji: 'Y方向の向き',
  }
  B_Z_ORIENTATION = {
    hiragana: 'Zほうこうのむき',
    kanji: 'Z方向の向き',
  }

  // Operators
  C_OPERATORS = {
    hiragana: 'えんざん',
    kanji: '演算',
  }
  B_RANDOM = {
    hiragana: '%1 から %2 までのらんすう',
    kanji: '%1 から %2 までの乱数',
  }
  B_NOT = {
    kanji: '%1 でない',
  }
  B_AND = {
    kanji: '%1 かつ %2',
  }
  B_OR = {
    kanji: '%1 または %2',
  }
  B_MOD = {
    hiragana: '%1 を %2 でわったあまり',
    kanji: '%1 を %2 で割った余り',
  }
  B_CONCATENATE = {
    kanji: '%1 と %2',
  }

  // Sensing
  C_SENSING = {
    hiragana: 'しらべる',
    kanji: '調べる',
  }
  B_TIMER = {
    kanji: 'タイマー',
  }

  // Sound
  C_SOUND = {
    hiragana: 'おと',
    kanji: '音',
  }
  B_PLAY_SOUND = {
    hiragana: 'おとをならす',
    kanji: '音を鳴らす',
  }
  B_VOLUME = {
    hiragana: 'おんりょう',
    kanji: '音量',
  }
  B_CHANGE_VOLUME_BY = {
    hiragana: 'おんりょうを %1 ずつかえる',
    kanji: '音量を %1 ずつ変える',
  }
  B_SET_VOLUME_TO = {
    hiragana: 'おんりょうを %1 ％にする',
    kanji: '音量を %1 ％にする',
  }

  // Variables
  C_VARIABLES = {
    hiragana: 'へんすう',
    kanji: '変数',
  }
  B_SET_VARIABLE_TO = {
    kanji: '%1 を %2 にする',
  }
  B_CHANGE_VARIABLE_BY = {
    hiragana: '%1 を %2 ずつかえる',
    kanji: '%1 を %2 ずつ変える',
  }
  B_MAKE_NEW_VARIABLE = {
    hiragana: 'へんすうをつくる',
    kanji: '変数を作る',
  }
  enter_variable_name = {
    kanji: '変数の名前を入力してください',
    hiragana: 'へんすうのなまえをにゅうりょくしてください',
  }
  rename_variable = {
    kanji: '変数の名前を変える',
    hiragana: 'へんすうのなまえをかえる',
  }
  variable_name_invalid_char = {
    kanji:
      '変数の名前は半角のアルファベット、半角の数字、「 _ 」以外使えません。',
    hiragana:
      'へんすうのなまえははんかくのアルファベット、はんかくのすうじ、「 _ 」いがいつかえません。',
  }
  variable_name_invalid_start = {
    kanji: '変数の名前の最初に数字は使えません。',
    hiragana: 'へんすうのなまえのさいしょにすうじはつかえません。',
  }
  variable_name_invalid_start_underscore = {
    kanji: '_（アンダーバー）から始まる名前は作れません。',
    hiragana: '_（アンダーバー）からはじまるなまえはつくれません。',
  }
  variable_name_reserved = {
    kanji: '使うことができない名前です。違う名前にしてください。',
    hiragana: 'つかうことができないなまえです。ちがうなまえにしてください。',
  }
  variable_name_in_use = {
    kanji: '変数「%1」はすでに存在します。',
    hiragana: 'へんすう「%1」はすでにそんざいします。',
  }

  // Procedures
  C_PROCEDURES = {
    kanji: 'ブロック',
  }
  B_MAKE_NEW_PROCEDURE = {
    hiragana: 'ブロックをつくる',
    kanji: 'ブロックを作る',
  }

  // Override default Blockly messages.
  // Blockly.Msg["ADD_COMMENT"] = "コメントを追加";
  ADD_COMMENT = {
    kanji: locale.ADD_COMMENT,
    hiragana: 'コメントをついか',
  }
  // Blockly.Msg["CLEAN_UP"] = "ブロックを整理する";
  CLEAN_UP = {
    kanji: locale.CLEAN_UP,
    hiragana: 'ブロックをせいりする',
  }
  // Blockly.Msg["COLLAPSE_ALL"] = "ブロックを折りたたむ";
  COLLAPSE_ALL = {
    kanji: locale.COLLAPSE_ALL,
    hiragana: 'ブロックをおりたたむ',
  }
  // Blockly.Msg["COLLAPSE_BLOCK"] = "ブロックを折りたたむ";
  COLLAPSE_BLOCK = {
    kanji: locale.COLLAPSE_BLOCK,
    hiragana: 'ブロックをおりたたむ',
  }
  // Blockly.Msg["DELETE_BLOCK"] = "ブロックを削除";
  DELETE_BLOCK = {
    kanji: locale.DELETE_BLOCK,
    hiragana: 'ブロックをさくじょ',
  }
  // Blockly.Msg["DELETE_VARIABLE"] = "変数 '%1' を削除";
  DELETE_VARIABLE = {
    kanji: locale.DELETE_VARIABLE,
    hiragana: "へんすう '%1' をさくじょ",
  }
  // Blockly.Msg["DELETE_X_BLOCKS"] = "%1個のブロックを削除";
  DELETE_X_BLOCKS = {
    kanji: locale.DELETE_X_BLOCKS,
    hiragana: '%1このブロックをさくじょ',
  }
  // Blockly.Msg["DISABLE_BLOCK"] = "ブロックを無効にする";
  DISABLE_BLOCK = {
    kanji: locale.DISABLE_BLOCK,
    hiragana: 'ブロックをむこうにする',
  }
  // Blockly.Msg["DUPLICATE_BLOCK"] = "複製";
  DUPLICATE_BLOCK = {
    kanji: 'コピー',
    hiragana: 'コピー',
  }
  // Blockly.Msg["ENABLE_BLOCK"] = "ブロックを有効にする";
  ENABLE_BLOCK = {
    kanji: locale.ENABLE_BLOCK,
    hiragana: 'ブロックをゆうこうにする',
  }
  // Blockly.Msg["EXPAND_ALL"] = "ブロックを展開する";
  EXPAND_ALL = {
    kanji: locale.EXPAND_ALL,
    hiragana: 'ブロックをてんかいする',
  }
  // Blockly.Msg["EXPAND_BLOCK"] = "ブロックを展開する";
  EXPAND_BLOCK = {
    kanji: locale.EXPAND_BLOCK,
    hiragana: 'ブロックをてんかいする',
  }
  // Blockly.Msg["EXTERNAL_INPUTS"] = "外部入力";
  EXTERNAL_INPUTS = {
    kanji: locale.EXTERNAL_INPUTS,
    hiragana: 'がいぶにゅうりょく',
  }
  // Blockly.Msg["INLINE_INPUTS"] = "インライン入力";
  INLINE_INPUTS = {
    kanji: locale.INLINE_INPUTS,
    hiragana: 'インラインにゅうりょく',
  }
  // Blockly.Msg["REDO"] = "やり直す";
  REDO = {
    hiragana: 'すすめる',
    kanji: '進める',
  }
  // Blockly.Msg["REMOVE_COMMENT"] = "コメントを削除";
  REMOVE_COMMENT = {
    kanji: locale.REMOVE_COMMENT,
    hiragana: 'コメントをさくじょ',
  }
  // Blockly.Msg["RENAME_VARIABLE"] = "変数の名前を変える…";
  RENAME_VARIABLE = {
    kanji: locale.RENAME_VARIABLE,
    hiragana: 'へんすうのなまえをかえる…',
  }
  // Blockly.Msg["RENAME_VARIABLE_TITLE"] = "「%1」という名前の変数名をすべて変える：";
  RENAME_VARIABLE_TITLE = {
    kanji: locale.RENAME_VARIABLE_TITLE,
    hiragana: '「%1」というなまえのへんすうめいをすべてかえる：',
  }
  // Blockly.Msg["UNDO"] = "取り消す";
  UNDO = {
    hiragana: 'もどる',
    kanji: '戻る',
  }
}

export const commonResource = new CommonResource()

const blockMessageEntries = Object.entries(commonResource).filter(
  ([, v]) => typeof v === 'object' && v?.kanji,
)

export const kanji = {
  ...locale,
  ...Object.fromEntries(blockMessageEntries.map(([k, v]) => [k, v.kanji])),
}

export const hiragana = {
  ...kanji,
  ...Object.fromEntries(
    blockMessageEntries
      .filter(([, v]) => v.hiragana)
      .map(([k, v]) => [k, v.hiragana]),
  ),
}
